import styled from 'styled-components';

export const WidgetSpacer = styled.div<{
  isOverlap: boolean;
}>`
  ${({ isOverlap }) => (isOverlap ? 'padding-top:64px !important' : '')};
`;

export const WidgetContainer = styled.div<{
  isLastWidget: boolean;
}>`
  padding-bottom: ${({ isLastWidget }) => (isLastWidget ? '109px' : 0)};
`;

export const FormContainer = styled.div<{ isLastWidget: boolean }>`
  padding-bottom: ${({ isLastWidget }) => (isLastWidget ? '50px' : 0)};
`;

export const WidgetDivider = styled.div`
  margin-top: 64px;
`;

